<template>
  <div class="sidebar-operation">
    <div class="avatar-icon">
      <input type="file" ref="avatarInput" id="avatarInput" style="display: none" @change="handleFileChange" />
      <div class="common-complex-avatar-wrapper" @click="triggerAvatarInputInput">
        <div>
          <span class="m-badge m-badge-status">
            <span class="m-avatar m-avatar-circle m-avatar-image">
              <img :src="avatar" alt="">
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'SidebarAvatar',
  computed: {
    ...mapState({
      imAccount: state => state.imAccount
    }),
    avatar () {
      return this.imAccount.im_icon ? this.imAccount.im_icon : 'https://yx-web-nosdn.netease.im/quickhtml/assets/yunxin/default/g2-demo-avatar-imgs/86117881728733184.jpg'
    }
  },
  data () {
    return {}
  },
  methods: {
    ...mapActions(['setMyAvatar', 'updateMyInfo']),
    triggerAvatarInputInput () {
      console.log('我被点击了', this.imAccount)
      this.$refs.avatarInput.click()
    },
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        this.setMyAvatar({ done: this.setMyAvatarDone })
      } else {
        console.log('选择文件失败')
      }
    },
    setMyAvatarDone (err, data) {
      if (!err) {
        let userInfo = { avatar: data.url }
        this.updateMyInfo({ userInfo, done: this.updateDone })
      }
    },
    updateDone (error, user) {
      console.log('更新我的名片' + (!error?'成功':'失败'))
      if (!error) {
        let account = this.imAccount
        account.im_icon = user.avatar
        this.$store.dispatch('changeImAccountStoreAction', account)
        this.updateServiceInfo({ id: account.id, im_icon: user.avatar })
      }
    },
    updateServiceInfo (data) {
      axios.post('/api/im/updateAccount', data, { loadingClose: true }).then((res) => {
        const responseData = res.data
        if (responseData.code !== 0) console.log('更新服务端信息失败')
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.avatar-icon {
  margin: 20px 0 25px;
  border-radius: 50%;
  border: 1px solid #e8e8e8;
}
.common-complex-avatar-wrapper {
  width: fit-content;
  cursor: pointer;
}
.m-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}
.m-avatar {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  vertical-align: middle;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  border-radius: 8px;
}
.m-avatar-image {
  background: transparent;
}
.m-avatar>img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/common/im/leftSidebar/SidebarAvatar.vue